import React from 'react'
import type { IntlShape } from 'react-intl'

export function getContentFAQ(intl: IntlShape) {
  return [
    {
      question: (
        <div className="font-weight-medium flexbox-grow">
          {intl.formatMessage({
            defaultMessage: 'Committing to less CO2 per worker',
            id: 'about.page.sustainability.faq.question1',
          })}
        </div>
      ),
      answer: (
        <span className="font-size-6">
          {intl.formatMessage({
            defaultMessage:
              'Our commitment is not just empty words - we measure our impact in tons of CO2 per worker, with the aim of reducing that number each year.',
            id: 'about.page.sustainability.faq.answer1',
          })}
        </span>
      ),
    },
    {
      question: (
        <div className="font-weight-medium width-full">
          {intl.formatMessage({
            defaultMessage: 'Sustainable compensation',
            id: 'about.page.sustainability.faq.question2',
          })}
        </div>
      ),
      answer: (
        <span className="font-size-6">
          {intl.formatMessage({
            defaultMessage:
              'We offer competitive salaries that are location-based, so as not to disrupt local economies.',
            id: 'about.page.sustainability.faq.answer2',
          })}
        </span>
      ),
    },
    {
      question: (
        <div className="font-weight-medium">
          {intl.formatMessage({
            defaultMessage: 'Sustainable growth.',
            id: 'about.page.sustainability.faq.question3',
          })}
        </div>
      ),
      answer: (
        <span className="font-size-6">
          {intl.formatMessage({
            defaultMessage:
              "When we bring someone onboard, we hope they'll stay for a very long time. Chasing investment is much less important than building a business that will grow old with us.",
            id: 'about.page.sustainability.faq.answer3',
          })}
        </span>
      ),
    },
    {
      question: (
        <div className="font-weight-medium">
          {intl.formatMessage({
            defaultMessage: 'No commute.',
            id: 'about.page.sustainability.faq.question4',
          })}
        </div>
      ),
      answer: (
        <span className="font-size-6">
          {intl.formatMessage({
            defaultMessage:
              "It's an obvious perk of remote work — no wasted fuel getting to and from an office in an urban center.",
            id: 'about.page.sustainability.faq.answer4',
          })}
        </span>
      ),
    },
    {
      question: (
        <div className="font-weight-medium">
          {intl.formatMessage({
            defaultMessage: 'Thoughtful swag.',
            id: 'about.page.sustainability.faq.question5',
          })}
        </div>
      ),
      answer: (
        <span className="font-size-6">
          {intl.formatMessage({
            defaultMessage:
              'Just like we hope our people stay their whole career, our company swag is built to last — and from recycled materials, too. And merch is totally optional — choose what swag you want, when you want it.',
            id: 'about.page.sustainability.faq.answer5',
          })}
        </span>
      ),
    },
  ]
}
